module.exports = __webpack_public_path__ + "img/fireImg.8e8b2d71.png";